import { render, staticRenderFns } from "./productRegistration.vue?vue&type=template&id=7d3026bc&scoped=true&"
import script from "./productRegistration.vue?vue&type=script&lang=js&"
export * from "./productRegistration.vue?vue&type=script&lang=js&"
import style0 from "./productRegistration.vue?vue&type=style&index=0&id=7d3026bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3026bc",
  null
  
)

export default component.exports